import * as React from 'react';
import DriveItemDeleteButton from '../../../containers/DriveItem/DeleteButton';
import DownloadGroupButton from '../../../containers/DriveItem/DownloadGroupButton';
import { ActionButtonStyle } from '../../../utils/driveItem';
import { ButtonContainer } from '../styles';
import UserAgentUtils from '../../../utils/userAgent';
import UpdateFolderTreeButton from '../../../containers/ParametersPage/ActionButtons/UpdateFolderTreeButton';

interface ActionButtonsProps {
	hasDownloadedItems: boolean;
	importantAssetsEnabled: boolean;
}

const ActionButtons = (props: ActionButtonsProps) => {
	const { hasDownloadedItems, importantAssetsEnabled } = props;
	const { isMobileApp } = UserAgentUtils;

	return (
		<ButtonContainer>
			{isMobileApp &&
				<>
					<DownloadGroupButton/>
					{importantAssetsEnabled &&
						<DownloadGroupButton isOnlyImportants={true} />
					}
				</>
			}
			{hasDownloadedItems &&
				<DriveItemDeleteButton style={ActionButtonStyle.ParametersPage} />
			}
			{isMobileApp && <UpdateFolderTreeButton />}
		</ButtonContainer>
	);
};

export default ActionButtons;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ParametersPage/ActionButtons/index.tsx